import { render, staticRenderFns } from "./login-header.vue?vue&type=template&id=9ce3d7d4"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"
import style0 from "./login-header.vue?vue&type=style&index=0&id=9ce3d7d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports